import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '../../Button'
import ModalAutoTaskReminders, {
	BaseModalAutoTaskRemindersProps,
} from './ModalAutoTaskReminders'
import LayoutRow from '../../layout/LayoutRow'

const AutoTaskRemindersIntervalsField = (
	props: BaseModalAutoTaskRemindersProps
) => {
	const { formatMessage } = useIntl()
	const { data } = props

	const [visible, setVisible] = React.useState(false)
	const handleOpenClick = () => {
		setVisible(true)
	}
	const handleClose = () => {
		setVisible(false)
	}

	return (
		<>
			<LayoutRow>
				<p>
					{formatMessage(
						{
							id: 'auto_task_reminders.reminders_set',
						},
						{ count: data?.length }
					)}
				</p>
			</LayoutRow>
			<Button
				text={formatMessage({
					id: 'auto_task_reminders.open_settings',
				})}
				variant="outlined"
				onClick={handleOpenClick}
			/>
			{visible && (
				<ModalAutoTaskReminders
					open={visible}
					onClose={handleClose}
					{...props}
				/>
			)}
		</>
	)
}

export default AutoTaskRemindersIntervalsField
